/**
 * API utilities for Propheseer
 */

import { API_ENDPOINTS, POLLING_CONFIG } from '../config';

/**
 * Create a new forecast
 */
export async function createForecast(data) {
  const response = await fetch(API_ENDPOINTS.createForecast, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to create forecast');
  }

  return response.json();
}

/**
 * Get forecast by ID
 */
export async function getForecast(forecastId) {
  const response = await fetch(API_ENDPOINTS.getForecast(forecastId));

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch forecast');
  }

  return response.json();
}

/**
 * Get specific round data
 */
export async function getForecastRound(forecastId, round) {
  const response = await fetch(API_ENDPOINTS.getForecastRound(forecastId, round));

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch round data');
  }

  return response.json();
}

/**
 * Poll forecast status until complete
 */
export async function pollForecastStatus(forecastId, onUpdate = null) {
  let attempts = 0;
  const maxAttempts = POLLING_CONFIG.maxAttempts;
  const terminalStatuses = ['complete', 'error'];

  while (attempts < maxAttempts) {
    const forecast = await getForecast(forecastId);

    if (onUpdate) {
      onUpdate(forecast);
    }

    if (terminalStatuses.includes(forecast.status)) {
      return forecast;
    }

    await new Promise(resolve => setTimeout(resolve, POLLING_CONFIG.interval));
    attempts++;
  }

  throw new Error('Polling timeout: Processing took too long');
}
